export default "__VITE_PUBLIC_ASSET__82d69ffc__"